import script from "./AdminApiClientsView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminApiClientsView.vue?vue&type=script&setup=true&lang=js"

import "./AdminApiClientsView.vue?vue&type=style&index=0&id=03fc1030&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03fc1030"]])

export default __exports__